import { createApi } from "@reduxjs/toolkit/query/react";
import fetchBaseQueryCSRF from "../helper";

// Visibility API (ads)
const visibility = createApi({
    baseQuery: fetchBaseQueryCSRF({ baseUrl: process.env.CROSS_API_URL }),
    reducerPath: "api.visibility",
    tagTypes: ["visibility"],
    endpoints: (builder) => ({
        
        // All ads data
        getAdsData: builder.query<any, {
            startDate: string | null,
            endDate: string | null,
            device: string[] | null,
            countries: string[],
            keywords: string[],
            workspaceTable?: any,
            workspaceId?: any,
            domain?: string,
            platform: any
        }>({
            query: ({ startDate, endDate, device, countries, keywords, workspaceTable, workspaceId, domain, platform }) => {
                const url = `/visibility/ads/getAdsData`;
                const body = {
                    startDate,
                    endDate,
                    device,
                    countries,
                    keywords,
                    workspaceTable,
                    workspaceId,
                    domain,
                    platform,
                };
                return {
                    url,
                    method: "POST",
                    body: JSON.stringify(body),
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache",
                        Accept: "application/json",
                    },
                };
            },
        }),

        // Keywords with paid presence rate for a selected domain
        getKeywordPresence: builder.query<any, {
            startDate: string | null,
            endDate: string | null,
            device: string[] | null,
            countries: string[],
            domain: string,
            workspaceTable?: any,
            platform?: any,
        }>({
            query: ({ startDate, endDate, device, countries, domain, workspaceTable, platform }) => ({
                url: `/visibility/ads/getKeywordPresence`,
                method: "POST",
                body: JSON.stringify({ startDate, endDate, device, countries, domain, workspaceTable, platform }),
                headers: {
                    "Content-Type": "application/json",
                    "Cache-Control": "no-cache",
                    Accept: "application/json",
                },
            }),
        }),

        // Side queries (top competitors global + by ad when adType provided)
        getSideQueries: builder.query<any, {
            startDate: string | null,
            endDate: string | null,
            device: string[] | null,
            countries: string[],
            keywords: string[],
            workspaceTable?: any,
            workspaceId?: any,
            domain?: string,
            platform: any,
            adType?: string[]
        }>({
            query: ({ startDate, endDate, device, countries, keywords, workspaceTable, workspaceId, domain, platform, adType }) => {
                const url = `/visibility/ads/getSideQueries`;
                const body = {
                    startDate,
                    endDate,
                    device,
                    countries,
                    keywords,
                    workspaceTable,
                    workspaceId,
                    domain,
                    platform,
                    adType,
                };
                return {
                    url,
                    method: "POST",
                    body: JSON.stringify(body),
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache",
                        Accept: "application/json",
                    },
                };
            },
        }),
    }),
});

export const {
    useGetAdsDataQuery,
    useGetSideQueriesQuery,
    useGetKeywordPresenceQuery,
} = visibility;

export default visibility;


